import { useCallback, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { PaywallPopup } from '../../Paywall/PaywallPopup/PaywallPopup';
import { config } from '../../../config';
import { useViewObserver } from '../../utils/useViewObserver';
import { useEngagementTracking } from '../../utils/useEngagementTracking';
import { ActionButton } from '../ActionButton/ActionButton';
import { isHermesApp, isIOS } from '../../../utils/device';

import type { FC } from 'react';

const getPaywallType = () => {
  if (config.provider === 'vgtv') {
    if (isHermesApp && isIOS) {
      return 'article';
    }

    return 'popup';
  }

  return 'fallback';
};

type SubscribeButtonProps = {
  label?: string;
};

export const SubscribeButton: FC<SubscribeButtonProps> = ({ label }) => {
  const ref = useRef<HTMLButtonElement>(null!);
  const [isOpen, setIsOpen] = useState(false);
  const [paywallType, setPaywallType] = useState<
    'fallback' | 'article' | 'popup'
  >(() => getPaywallType());
  const { t } = useTranslation();
  const { trackClick, trackView } = useEngagementTracking(
    'header-subscribe-button'
  );

  useViewObserver({
    onView: trackView,
    elementRef: ref,
  });

  const handleClick = () => {
    trackClick('Open');

    if (paywallType === 'popup') {
      setIsOpen(true);
    } else if (
      paywallType === 'article' &&
      config.subscription.salesposterArticle
    ) {
      window.location.href = config.subscription.salesposterArticle;
    } else {
      window.location.href = config.subscription.landingPageUrl;
    }
  };

  const handleLoadFailure = useCallback(() => {
    setIsOpen(false);
    setPaywallType('fallback');
  }, []);

  return (
    <>
      <ActionButton buttonRef={ref} onClick={handleClick}>
        {label?.trim() || t('Subscribe to watch')}
      </ActionButton>
      {paywallType === 'popup' && (
        <PaywallPopup
          isOpen={isOpen}
          onCloseButtonClick={() => setIsOpen(false)}
          access="plus"
          section="kjop"
          onLoadFailure={handleLoadFailure}
        />
      )}
    </>
  );
};
